import { EventCard } from "../../components/activities/EventCard";
import type { EventGridComponent } from "../../types";
import { GuardedLink } from "../../runtime/DevPlaceholder";
import { resolveLinkHref } from "../../utils/links";

/** Event grid renderer with cards and optional CTA link. Cards with a non-connected
 *  destination open the dev modal in preview and are hidden in production (EventCard);
 *  same rules for the CTA link below the grid. */
export function EventGridRenderer({ component }: { component: EventGridComponent }) {
  const { items, ctaHref, ctaLabel } = component.content;
  return (
    <section>
      <div className="grid gap-4 sm:gap-6 md:grid-cols-3">
        {items.map((e, i) => (
          <EventCard key={`${e.title}-${i}`} {...e} />
        ))}
      </div>
      {resolveLinkHref(ctaHref) && ctaLabel ? (
        <div className="mt-4">
          <GuardedLink href={ctaHref} label={ctaLabel} className="inline-flex items-center gap-1 text-[#0095DB] hover:underline" style={{ fontFamily: "var(--font-aleo)" }}>
            {ctaLabel}
            <span aria-hidden>›</span>
          </GuardedLink>
        </div>
      ) : null}
    </section>
  );
}
